<template>
  <div class="m--skin-login" style="height: 100%">
    <header>
      <div class="m-header__top t3-header"></div>
    </header>
    <div class="m-grid m-grid--hor m-grid--root m-page">
      <div
        class="m-grid__item m-grid__item--fluid m-grid m-grid--hor m-login m-login--signin m-login--2 m-login-2--skin-2"
        id="m_login">
        <div class="m-grid__item m-grid__item--fluid m-login__wrapper">
          <div class="m-login__container">
            <div class="m-login__signup" style="display: block">
              <div class="m-login__head">
                <h3 class="m-login__title">Confirm Acount</h3>
                <div class="m-login__desc">
                  Please enter code received to confirm account
                </div>
              </div>
              <div class="m-login__form m-form">
                <div class="form-group m-form__group" :class="{'has-danger': errors.has('phoneNo') }">
                  <div class="input-group m-input-group">
                    <input type="text" class="form-control form-no-b--l m-input" id="phoneNo" name="phoneNo" v-validate="'required'"
                           data-vv-as="phone number" v-model="phoneNo">
                    <span class="input-group-btn">
                        <button @click="resendCode" class="btn m-btn--resend" type="button">
                          {{ resending }}
                        </button>
                      </span>
                  </div>
                  <small v-show="errors.has('phoneNo')" class="form-control-feedback">
                    {{ errors.first('phoneNo') }}
                  </small>
                </div>
                <div class="form-group m-form__group" :class="{'has-danger': errors.has('code') }">
                  <input type="text" class="form-control empty" id="code" name="code" placeholder="Code"
                         v-validate="'required'" v-model="code">
                  <small v-show="errors.has('code')" class="form-control-feedback">{{ errors.first('code') }}</small>
                </div>
                <div class="m-login__form-action">
                  <button @click="verifyPhone" class="btn btn-custome-login btn-block m-btn- m-btn--custom
                    m-btn--air m-login__btn m-login__btn--custome"
                          v-text="loading"></button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "../../api";
  import helper from "../../helpers";
  import Welcome from "../partials/Welcome";

  export default {
    data() {
      return {
        oldPhone: this.$store.state.user.phoneNo ||
        JSON.parse(window.localStorage.getItem("user")).phoneNo,
        phoneNo: this.$store.state.user.phoneNo ||
        JSON.parse(window.localStorage.getItem("user")).phoneNo,
        user: this.$store.state.user ||
        JSON.parse(window.localStorage.getItem("user")),
        token: this.$store.state.confirmToken ||
        window.localStorage.getItem("confirm_token"),
        code: "",
        resending: "Resend Code",
        loading: "Confirm Account",
        phoneNoChanged: "0"
      };
    },
    components: {
      welcome: Welcome
    },
    methods: {
      verifyPhone() {
        this.$validator
          .validateAll()
          .then(valid => {
            if (valid) {
              if (this.oldPhone !== this.phoneNo) {
                helper
                  .questionAlert("Would you like to change to new phone number?")
                  .then(() => {
                    this.phoneNoChanged = "1";
                    this.completeVerification();
                  });
              } else {
                this.completeVerification();
              }
            }
          })
          .catch(() => {
            console.log("Form validations failed");
          });
      },
      completeVerification() {
        let {phoneNo, code, token, phoneNoChanged} = this;
        const txType = "verify-phone-no";
        this.loading = "Loading...";
        api
          .request(txType, {phoneNo, code, token, phoneNoChanged})
          .then(response => {
            let data = response.data;
            if (data.status === "00") {
              this.$store.commit("SET_TOKEN", this.token);
              this.$store.commit("SET_USER", this.user);
              this.$store.commit("SET_CONFIRM_TOKEN", null);

              if (window.localStorage) {
                window.localStorage.setItem("token", this.token);
                window.localStorage.setItem("user", JSON.stringify(this.user));
                window.localStorage.removeItem("confirm_token");
              }

              helper.successAlert("Account confirmed successfully").then(() => {
                this.$router.push("/");
              });
            } else {
              this.loading = "Confirm Account";
              helper.errorAlert(data.message);
            }
          })
          .catch(error => {
            this.loading = "Confirm Account";
            helper.errorAlert(
              "Sorry, we are unable to confirm your account at this time. Please try again later"
            );
            console.log(error);
          });
      },
      resendCode() {
        this.$validator
          .validate("phoneNo", this.phoneNo)
          .then(valid => {
            if (valid) {
              if (this.oldPhone !== this.phoneNo) {
                helper
                  .questionAlert("Would you like to change to new phone number?")
                  .then(response => {
                    if (response.value) {
                      this.oldPhone = this.phoneNo;
                      this.completeResendCode();
                    }
                  });
              } else {
                this.completeResendCode();
              }
            }
          })
          .catch(() => {
            console.log("Phone number validation failed");
          });
      },
      completeResendCode() {
        let {phoneNo, token} = this;
        const txType = "resend-verification-code";
        this.resending = "Resending...";
        api
          .request(txType, {phoneNo, token})
          .then(response => {
            let data = response.data;
            if (data.status === "00") {
              this.resending = "Resend Code";
              helper.successAlert("Code has been resent successfully");
            } else {
              this.resending = "Resend Code";
              helper.errorAlert(data.message);
            }
          })
          .catch(error => {
            this.resending = "Resend Code";
            helper.errorAlert(
              "Sorry, we are unable to resend code at this time. Please try again later"
            );
            console.log(error);
          });
      }
    },
    mounted() {
      if (!this.token) {
        this.$router.push("/");
      }
    }
  };
</script>



// WEBPACK FOOTER //
// src/components/auth/Confirm.vue